import { render, staticRenderFns } from "./properties-block-columns.vue?vue&type=template&id=4dfb1870&scoped=true"
import script from "./properties-block-columns.vue?vue&type=script&lang=js"
export * from "./properties-block-columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb1870",
  null
  
)

export default component.exports